<form *ngIf="contractOutgoingMailFormGroup" [formGroup]="contractOutgoingMailFormGroup">
    <div class="grid">
        <div class="col-4 input-field">
            <label for="outgoingMailResourceType">Tipo</label>
            <p-dropdown [options]="contractsOutgoingMailResourceType" formControlName="outgoingMailResourceType" [required]="true" optionValue="id"
                [filter]="true" filterBy="name" optionLabel="name" placeholder="Seleccione tipo" appendTo="body"
                d-form-field-error />
        </div>
        <div class="col-4 input-field">
            <label for="mailAccountId">Cuenta de correo remitente</label>
            <p-dropdown [options]="mailAccounts" formControlName="mailAccountId" [required]="true" optionValue="id"
                [filter]="true" filterBy="username" optionLabel="username" placeholder="Seleccione cuenta de correo"
                appendTo="body" d-form-field-error />
        </div>
        <div class="col-4 input-field">
            <label for="mailTo">Email de destino</label>
            <input pInputText name="mailTo" formControlName="mailTo" d-form-field-error />
        </div>
    </div>

    <div class="mt-4 flex gap-2 justify-content-end">
        <p-button label="Eliminar" *ngIf="allowDelete && contractOutgoingMail.id" icon="pi pi-trash"
            styleClass="p-button-danger" (click)="delete()"></p-button>
        <div class="flex-grow-1"></div>
        <p-button label="Cancelar" icon="pi pi-times" styleClass="p-button-secondary" (click)="cancel()"></p-button>
        <p-button label="Guardar" *ngIf="allowWrite" icon="pi pi-check" styleClass="p-ml-2" (click)="save()"></p-button>
    </div>

</form>